function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M27.65 13.183L23.567 9.1a1.128 1.128 0 00-1.634 0 1.128 1.128 0 000 1.633l2.1 2.1h-8.866V3.967l2.1 2.1a1.128 1.128 0 001.633 0 1.128 1.128 0 000-1.634L14.817.35a1.128 1.128 0 00-1.634 0L9.1 4.433a1.128 1.128 0 000 1.634 1.128 1.128 0 001.633 0l2.1-2.1v8.866H3.967l2.1-2.1a1.128 1.128 0 000-1.633 1.128 1.128 0 00-1.634 0L.35 13.183a1.128 1.128 0 000 1.634L4.433 18.9a1.128 1.128 0 001.634 0 1.128 1.128 0 000-1.633l-2.1-2.1h8.866v8.866l-2.1-2.1a1.128 1.128 0 00-1.633 0 1.128 1.128 0 000 1.634l4.083 4.083a1.128 1.128 0 001.634 0l4.083-4.083a1.128 1.128 0 000-1.634 1.128 1.128 0 00-1.633 0l-2.1 2.1v-8.866h8.866l-2.1 2.1a1.128 1.128 0 000 1.633 1.128 1.128 0 001.634 0l4.083-4.083a1.128 1.128 0 000-1.634z"
});

var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 28 28",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgDrag;